import React from "react";

const ViewTicketHistory = () => {
  return <div>ViewTicketHistory</div>;
};

export default ViewTicketHistory;
